class CustomSelect extends HTMLElement {
  connectedCallback() {
    console.log('=== CUSTOM SELECT CONNECTED ===');
    console.log('Element:', this);
    console.log('Element ID:', this.id);
    console.log('Element class:', this.className);
    
    this.toggleButton = this.querySelector('.custom-select-toggle');
    this.select = this.querySelector('select');
    this.desktopPopover = this.querySelector('.custom-select-popover.desktop');

    console.log('Toggle button found:', !!this.toggleButton);
    console.log('Select found:', !!this.select);
    console.log('Desktop popover found:', !!this.desktopPopover);

    // Check element positioning and clickability
    if (this.toggleButton) {
      const rect = this.toggleButton.getBoundingClientRect();
      console.log('Toggle button position:', {
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        visible: rect.width > 0 && rect.height > 0
      });
      console.log('Toggle button styles:', {
        display: window.getComputedStyle(this.toggleButton).display,
        visibility: window.getComputedStyle(this.toggleButton).visibility,
        pointerEvents: window.getComputedStyle(this.toggleButton).pointerEvents,
        zIndex: window.getComputedStyle(this.toggleButton).zIndex
      });
    }

    // Mobile popover container in theme.liquid
    this.mobilePopoverContainer = document.getElementById('mobile-custom-select-popover-container');

    // Build mobile popover dynamically
    this.buildMobilePopover();

    // Add debouncing to prevent rapid clicking
    this.debouncedTogglePopover = debounce(this.togglePopover.bind(this), 150);
    this.isProcessingClick = false;

    this.toggleButton.addEventListener('click', (e) => {
      console.log('=== TOGGLE BUTTON CLICKED ===');
      console.log('Button clicked for:', this.id);
      console.log('Event:', e);
      
      // Prevent rapid clicking
      if (this.isProcessingClick) {
        console.log('Click already being processed, ignoring...');
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      
      this.isProcessingClick = true;
      this.debouncedTogglePopover();
      
      // Reset processing flag after delay
      setTimeout(() => {
        this.isProcessingClick = false;
      }, 300);
    });

    document.addEventListener('click', e => {
      if (
        !this.contains(e.target) &&
        this.mobilePopover && !this.mobilePopover.contains(e.target)
      ) {
        this.closePopover();
      }
    });

    // Handle window resize to ensure mobile popover is properly updated
    window.addEventListener('resize', () => {
      if (this.mobilePopover) {
        this.rebuildMobilePopover();
      }
    });

    // Test the component functionality
    this.testComponent();
    
    console.log('=== CUSTOM SELECT CONNECTED COMPLETE ===');
  }

  testComponent() {
    console.log('=== TESTING COMPONENT FUNCTIONALITY ===');
    console.log('Toggle button clickable:', this.toggleButton && !this.toggleButton.disabled);
    console.log('Select has options:', this.select && this.select.options.length > 0);
    console.log('Mobile popover built:', !!this.mobilePopover);
    
    // Test if we can find the toggle button by ID
    const testButton = document.querySelector(`#${this.id} .custom-select-toggle`);
    console.log('Can find toggle button by ID:', !!testButton);
    
    // Test if the element is in the DOM
    console.log('Element in DOM:', document.contains(this));
    console.log('Toggle button in DOM:', this.toggleButton ? document.contains(this.toggleButton) : false);
    
    console.log('=== END COMPONENT TEST ===');
  }

  // Inside CustomSelect class
  buildMobilePopover() {
    try {
      console.log('=== BUILDING MOBILE POPOVER ===');
      const optionLabel = this.select.name.replace(/^options\[|\]$/g, '');
      console.log('Building mobile popover for:', optionLabel);
    
      this.mobilePopover = document.createElement('div');
      this.mobilePopover.className = 'custom-select-mobile-overlay';
    
      this.mobilePopover.innerHTML = `
        <div class="custom-select-popover mobile">
          <div class="popover-header">
            <span class="title">${optionLabel}</span>
            <button class="close-button" aria-label="Close">&times;</button>
          </div>
          <ul class="popover-options">
            ${Array.from(this.select.options).map(option => {
              const isSelected = option.value === this.select.value;
              const isDisabled = option.disabled || option.style.display === 'none';
              const disabledClass = isDisabled ? 'disabled' : '';
              const selectedClass = isSelected ? 'selected' : '';
              const displayStyle = isDisabled ? 'style="display: none;"' : '';
              
              return `<li role="option" data-value="${option.value}" class="${disabledClass} ${selectedClass}" ${displayStyle}>
                ${option.textContent}
              </li>`;
            }).join('')}
          </ul>
        </div>
      `;
    
      this.mobilePopover.style.display = 'none';
      document.body.appendChild(this.mobilePopover);
      
      console.log('Mobile popover built and appended to body');
      console.log('Mobile popover element:', this.mobilePopover);
    
      // Close on close button
      this.mobilePopover.querySelector('.close-button')
        .addEventListener('click', () => this.closePopover());
    
      // Close when clicking on overlay (but NOT the bottom sheet itself)
      this.mobilePopover.addEventListener('click', (e) => {
        if (e.target === this.mobilePopover) {
          this.closePopover();
        }
      });
    
      // Option click handling
      this.mobilePopover.querySelectorAll('li').forEach(li => {
        li.addEventListener('click', () => this.selectOption(li));
      });

      if (this.desktopPopover) {
        this.desktopPopover.querySelectorAll('li').forEach(li => {
          li.addEventListener('click', () => this.selectOption(li));
        });
      }
      
      console.log('=== MOBILE POPOVER BUILT SUCCESSFULLY ===');
    } catch (error) {
      console.error('Error building mobile popover:', error);
      console.error('Select element:', this.select);
      console.error('Select options:', this.select ? Array.from(this.select.options).map(opt => opt.value) : 'No select found');
    }
  }

  rebuildMobilePopover() {
    try {
      if (this.mobilePopover) {
        this.mobilePopover.remove();
      }
      this.buildMobilePopover();
      
      // Sync with current select state
      this.syncWithSelect();
    } catch (error) {
      console.error('Error rebuilding mobile popover:', error);
    }
  }

  syncWithSelect() {
    try {
      console.log('=== SYNC WITH SELECT START ===');
      console.log('Select value:', this.select.value);
      
      // Update mobile popover to reflect current select state
      if (this.mobilePopover) {
        const mobileOptions = this.mobilePopover.querySelector('.popover-options');
        if (mobileOptions) {
          mobileOptions.querySelectorAll('li').forEach(li => {
            const value = li.dataset.value;
            const option = this.select.querySelector(`option[value="${value}"]`);
            
            if (option) {
              // Only update disabled state if the option is not already managed by variant picker
              const isDisabled = option.disabled || option.style.display === 'none';
              const isCurrentlyDisabled = li.classList.contains('disabled');
              
              console.log(`Mobile option "${value}": select disabled=${isDisabled}, currently disabled=${isCurrentlyDisabled}`);
              
              // Don't override if the variant picker has already set the availability
              if (!isCurrentlyDisabled || isDisabled) {
                if (isDisabled) {
                  li.classList.add('disabled');
                  li.style.display = 'none';
                } else {
                  li.classList.remove('disabled');
                  li.style.display = '';
                }
              }
            }
          });
        }
      }
      
      // Update desktop popover as well
      if (this.desktopPopover) {
        this.desktopPopover.querySelectorAll('li').forEach(li => {
          const value = li.dataset.value;
          const option = this.select.querySelector(`option[value="${value}"]`);
          
          if (option) {
            // Only update disabled state if the option is not already managed by variant picker
            const isDisabled = option.disabled || option.style.display === 'none';
            const isCurrentlyDisabled = li.classList.contains('disabled');
            
            console.log(`Desktop option "${value}": select disabled=${isDisabled}, currently disabled=${isCurrentlyDisabled}`);
            
            // Don't override if the variant picker has already set the availability
            if (!isCurrentlyDisabled || isDisabled) {
              if (isDisabled) {
                li.classList.add('disabled');
                li.style.display = 'none';
              } else {
                li.classList.remove('disabled');
                li.style.display = '';
              }
            }
          }
        });
      }
      
      // Debug logging for mobile popover
      this.debugMobilePopoverState();
      console.log('=== SYNC WITH SELECT END ===');
    } catch (error) {
      console.error('Error in syncWithSelect:', error);
    }
  }

  debugMobilePopoverState() {
    if (this.mobilePopover) {
      const mobileOptions = this.mobilePopover.querySelector('.popover-options');
      if (mobileOptions) {
        console.log('=== MOBILE POPOVER DEBUG ===');
        console.log('Current select value:', this.select.value);
        console.log('Mobile popover options:');
        mobileOptions.querySelectorAll('li').forEach(li => {
          console.log(`- ${li.dataset.value}: selected=${li.classList.contains('selected')}, disabled=${li.classList.contains('disabled')}, display=${li.style.display}`);
        });
        console.log('=== END MOBILE POPOVER DEBUG ===');
      }
    } else {
      console.log('Mobile popover is null or undefined');
    }
  }

  checkMobilePopoverHealth() {
    console.log('=== MOBILE POPOVER HEALTH CHECK ===');
    console.log('Mobile popover exists:', !!this.mobilePopover);
    if (this.mobilePopover) {
      console.log('Mobile popover display style:', this.mobilePopover.style.display);
      console.log('Mobile popover classes:', this.mobilePopover.className);
      const mobileOptions = this.mobilePopover.querySelector('.popover-options');
      console.log('Mobile options container exists:', !!mobileOptions);
      if (mobileOptions) {
        console.log('Number of mobile options:', mobileOptions.querySelectorAll('li').length);
      }
    }
    console.log('=== END HEALTH CHECK ===');
  }

  togglePopover() {
    console.log('=== TOGGLE POPOVER DEBUG ===');
    console.log('Window width:', window.innerWidth);
    console.log('Mobile popover exists:', !!this.mobilePopover);
    console.log('Desktop popover exists:', !!this.desktopPopover);
    
    // Perform health check for mobile popover
    this.checkMobilePopoverHealth();
    
    if (window.innerWidth >= 768) {
      // Desktop toggle inline popover
      console.log('Desktop mode - toggling desktop popover');
      const isOpen = this.desktopPopover.classList.contains('open');
      if (isOpen) {
        this.closePopover();
      } else {
        this.openPopover();
      }
    } else {
      // Mobile toggle fixed popover
      console.log('Mobile mode - toggling mobile popover');
      if (this.mobilePopover && this.mobilePopover.style.display === 'block') {
        console.log('Mobile popover is open, closing...');
        this.closePopover();
      } else {
        console.log('Mobile popover is closed, opening...');
        this.openPopover();
      }
    }
    console.log('=== END TOGGLE POPOVER DEBUG ===');
  }

  openPopover() {
    if (window.innerWidth >= 768) {
      this.desktopPopover.classList.add('open');
    } else {
      // Ensure mobile popover exists and is synchronized before opening
      if (this.mobilePopover) {
        // Force sync with current select state before opening
        this.syncWithSelect();
        this.mobilePopover.style.display = 'block';
        document.body.classList.add('mobile-popover-open');
      } else {
        console.error('Mobile popover not found, rebuilding...');
        this.buildMobilePopover();
        this.syncWithSelect();
        this.mobilePopover.style.display = 'block';
        document.body.classList.add('mobile-popover-open');
      }
    }
    this.toggleButton.setAttribute('aria-expanded', 'true');
  }
  
  closePopover() {
    if (window.innerWidth >= 768) {
      this.desktopPopover.classList.remove('open');
    } else {
      if (this.mobilePopover) {
        const popover = this.mobilePopover.querySelector('.custom-select-popover.mobile');
        if (popover) {
          // Add slideDown animation class
          popover.classList.add('exiting');
  
          // Wait for animation to finish before hiding
          setTimeout(() => {
            this.mobilePopover.style.display = 'none';
            popover.classList.remove('exiting');
            document.body.classList.remove('mobile-popover-open');
          }, 300); // Match duration of slideDown
        }
      }
    }
  
    this.toggleButton.setAttribute('aria-expanded', 'false');
  }

  selectOption(li) {
  // Prevent selecting disabled/hidden
  if (li.classList.contains('disabled') || li.style.display === 'none') return;

  // Prevent rapid selection
  if (this.isProcessingSelection) {
    console.log('Selection already being processed, ignoring...');
    return;
  }
  
  this.isProcessingSelection = true;

  try {
    // Escape quotes in value for safe selector
    let selectedValue = li.dataset.value || li.textContent.trim();
    const safeValue = selectedValue.replace(/"/g, '\\"');

    // Find matching option in the hidden select
    const matchingOption = this.select.querySelector(`option[value="${safeValue}"]`);
    if (matchingOption) {
      this.select.value = matchingOption.value;
      selectedValue = matchingOption.value;
    } else {
      // Fallback: use visible text (in case of Hebrew / special chars)
      const textMatch = Array.from(this.select.options).find(opt => opt.text.trim() === li.textContent.trim());
      if (textMatch) {
        this.select.value = textMatch.value;
        selectedValue = textMatch.value;
      }
    }

    // Update board display IMMEDIATELY
    const board = this.toggleButton.querySelector('.custom-select__board');
    if (board) {
      board.textContent = li.textContent.trim();
      console.log('Updated display board to:', li.textContent.trim());
    }

    // Update selected state IMMEDIATELY
    if (this.desktopPopover) {
      this.desktopPopover.querySelectorAll('li').forEach(el => el.classList.remove('selected'));
      li.classList.add('selected');
    }
    if (this.mobilePopover) {
      const mobileOptions = this.mobilePopover.querySelector('.popover-options');
      if (mobileOptions) {
        mobileOptions.querySelectorAll('li').forEach(el => el.classList.remove('selected'));
        li.classList.add('selected');
      }
    }

    // Communicate with variant picker IMMEDIATELY
    const variantPicker = this.closest('variant-selects');
    if (variantPicker && typeof variantPicker.handleCustomSelectChange === 'function') {
      console.log('Communicating with variant picker for value:', selectedValue);
      variantPicker.handleCustomSelectChange(this, selectedValue);
    }

    // Trigger change with minimal delay
    setTimeout(() => {
      const changeEvent = new Event('change', { bubbles: true });
      this.select.dispatchEvent(changeEvent);
    }, 10);

    // --- MOBILE-ONLY FIX ---
    if (window.innerWidth < 768) {
      if (variantPicker) {
        if (typeof variantPicker.updateOptions === 'function') variantPicker.updateOptions();
        if (typeof variantPicker.updateMasterId === 'function') variantPicker.updateMasterId();
        if (typeof variantPicker.updateVariantInput === 'function') variantPicker.updateVariantInput();
        if (typeof variantPicker.updateURL === 'function') variantPicker.updateURL();
      }
    }

    this.closePopover();
  } finally {
    // Reset selection processing flag after delay
    setTimeout(() => {
      this.isProcessingSelection = false;
    }, 100);
  }
}

}

// Add debounce function if not already defined
if (typeof debounce === 'undefined') {
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('custom-select', CustomSelect);